export enum OnBehalfActionType {
  Accept=1,
  Reject=2,
  Confirm=3,
  Terminate=4,
  Reassign=5,
  TempAssign=6,
  ReassignCA=7,
  FirstAttend=8,
  SubmitOutreachFFS=9,
  AwardSystemRecommFFS=10,
  AssignCaseload=11,
  AcceptCase=12,
  RejectCase=13,
  WithdrawTx=14,
  GenerateOrder = 15,
  NeverServed = 16,
  RetroFirstAttend =17,
  RetroAssignProvider=18,
}

export enum WithdrawOrDecline {
  Withdraw,
  Decline,
}
export enum RequestPopupType {
  SelectServiceModel = 'SelectServiceModel',
  RequestContractAssistance = 'RequestContractAssistance',
  LocatePrimaryAgency = 'LocatePrimaryAgency',
  RequestLocationProvider = 'RequestLocationProvider',
  InitiateOutreachByDeadline = 'InitiateOutreachByDeadline',
  AssignProvider = 'AssignProvider',
  SubmitOutreachDWS = 'SubmitOutreachDWS',
  ReSubmitOBD = 'ReSubmitOBD',
  AwardDWS = 'AwardDWS',
  AssignCaseload = 'AssignCaseload',
  TransmitToRequestedAgency = 'TransmitToRequestedAgency',
  AcceptAssignToCaseload = 'AcceptAssignToCaseload',
  RejectDWS = 'RejectDWS',
  WithdrawTxDWS = 'WithdrawTxDWS',
}

export const MANDATE_ACTION_MAP = {
  OBD: {
    ffs: OnBehalfActionType.SubmitOutreachFFS,
    dws: RequestPopupType.SubmitOutreachDWS
  },
  AWARD: {
    ffs: OnBehalfActionType.AwardSystemRecommFFS,
    dws: RequestPopupType.AwardDWS
  },
  RejectCase: {
    ffs: OnBehalfActionType.RejectCase,
    dws: RequestPopupType.RejectDWS
  },
  withdrawTx: {
    ffs: OnBehalfActionType.WithdrawTx,
    dws: RequestPopupType.WithdrawTxDWS
  }
} 

export enum EvaluatorAssignmentType {
  AssignToNYCPS,
  ReturnToSchool,
  isContractOut,
  RespondWithEval
}
export enum AssignmentPanelButtonsType{
  RequestToConfirmCapacity ='RequestToConfirmCapacity',
  InitiateOutreachByDeadline ='InitiateOutreachByDeadline',
}

export enum AssignmentTabs {
  NYCPS_Evaluators = 'nycpsEvals',
  Contract_Out = 'contractOut',
  AA = 'AA',
  Providers = 'Providers',
  Agencies = 'Agencies',
  Bundles = 'Bundles',
}

export const perSessionId = 4

export const searchPlaceholderMap: Record<AssignmentTabs, string> = {
    [AssignmentTabs.NYCPS_Evaluators]: 'Search Name or ID',
    [AssignmentTabs.Contract_Out]: 'Search by Name or Tax ID',
    [AssignmentTabs.AA]: 'Search by Name or Pets Pri',
    [AssignmentTabs.Providers]: 'Search by Name or ID',
    [AssignmentTabs.Bundles]: 'Search by ID',
      [AssignmentTabs.Agencies]: 'Search by Name or TIN',
}
